import { render, staticRenderFns } from "./Professionalization.vue?vue&type=template&id=230e0b88&scoped=true"
import script from "./Professionalization.vue?vue&type=script&lang=js"
export * from "./Professionalization.vue?vue&type=script&lang=js"
import style0 from "./Professionalization.vue?vue&type=style&index=0&id=230e0b88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230e0b88",
  null
  
)

export default component.exports